module.exports = __webpack_public_path__ + "img/hkig.65ab13d0.png";